import { __decorate } from "tslib";
import Component from 'vue-class-component';
import CrudComponent from '@/classes/CrudComponent';
import { Prop } from 'vue-property-decorator';
import { INPUT_TYPES } from '@/constants/InputTypes';
import moment from 'moment';
let SimpleCrud = class SimpleCrud extends CrudComponent {
    showDeleted = false;
    title;
    disableFiltering;
    disablePagination;
    customFilter;
    sortBy;
    sortDesc;
    canAdd;
    canEditItem;
    hideDelete;
    hideShowDeletedToggle;
    isSuperseded;
    get allItems() {
        if (this.showDeleted) {
            return this.$store.getters[this.storeModule + '/allSortedForManagement'];
        }
        return this.$store.getters[this.storeModule + '/active'];
    }
    isDeleted(item) {
        return !!item.data?.deletedAt;
    }
    isItemSuperseded(item) {
        if (!this.isSuperseded)
            return false;
        return this.isSuperseded(item);
    }
    findDeep(obj, pathString) {
        return pathString.split('.').reduce((acc, cur) => {
            return acc[cur];
        }, obj);
    }
    get enabledHeaders() {
        return this.headers.filter((x) => this.enabled(x));
    }
    enabled(item) {
        if (item.notEditable) {
            return false;
        }
        if (item.readOnly && this.editedItem.id !== this.defaultItem.id) {
            return false;
        }
        if (item.editableFromRole && item.editableFromRole > this.$store.getters['user/role']) {
            return false;
        }
        return true;
    }
    get visibleHeaders() {
        return this.headers.filter(x => this.isVisible(x));
    }
    isVisible(item) {
        return !(item.visibleFromRole && item.visibleFromRole > this.$store.getters['user/role']);
    }
    toLocaleDateString(date) {
        if (!date) {
            return '';
        }
        const m = moment(date);
        return m.isValid() ? m.toDate().toLocaleDateString() : '';
    }
    getRules(item) {
        if (!item.specialRules) {
            return item.rules;
        }
        let rules = [
            ...item.rules
        ];
        for (const specialRule of item.specialRules) {
            rules.push(specialRule.rule(this.findDeep(this.editedItem, specialRule.path)));
        }
        return rules;
    }
    /**
     * Get validation rules for date fields.
     * Since the date text field displays a formatted value but validates against
     * the actual model value (YYYY-MM-DD), we need to apply rules to the model value.
     *
     * @param item - The header item with validation rules
     * @param modelValue - The actual date value in YYYY-MM-DD format
     * @returns Array of validation rules that validate against the model value
     */
    getDateRules(item, modelValue) {
        // Create wrapper functions that validate against the model value instead of displayed value
        return item.rules.map(rule => {
            return () => rule(modelValue);
        });
    }
    print(header, item) {
        let string = '';
        switch (header.type) {
            case INPUT_TYPES.SELECT:
                if (header.selectValue && header.selectText && header.selectItems) {
                    const foundItem = header.selectItems.find((value) => this.findDeep(value, header.selectValue) ===
                        this.findDeep(item, header.value));
                    if (typeof header.customPrint !== 'undefined') {
                        string = header.value;
                    }
                    else if (!foundItem) {
                        // Handle case when item is not found in selectItems
                        string = this.findDeep(item, header.value) || '';
                    }
                    else if (typeof header.selectText === 'string') {
                        string = this.findDeep(foundItem, header.selectText) || '';
                    }
                    else {
                        string = header.selectText(foundItem) || '';
                    }
                }
                else {
                    string = this.findDeep(item, header.value);
                }
                break;
            case INPUT_TYPES.MULTIPLE_SELECT:
                if (typeof header.customPrint !== 'undefined') {
                    for (const value of this.findDeep(item, header.value)) {
                        string += header.customPrint(value, item) + ', ';
                    }
                    return string;
                }
                string = this.findDeep(item, header.value)?.join(', ') ?? '';
                break;
            case INPUT_TYPES.DATE:
                // For DATE with customPrint, pass raw value so moment can parse it correctly
                if (typeof header.customPrint !== 'undefined') {
                    return header.customPrint(this.findDeep(item, header.value), item);
                }
                string = new Date(this.findDeep(item, header.value)).toLocaleDateString();
                break;
            default:
                string = this.findDeep(item, header.value);
        }
        return typeof header.customPrint !== 'undefined'
            ? header.customPrint(string, item)
            : string;
    }
};
__decorate([
    Prop({ required: true })
], SimpleCrud.prototype, "title", void 0);
__decorate([
    Prop({ required: true })
], SimpleCrud.prototype, "storeModule", void 0);
__decorate([
    Prop({ required: true })
], SimpleCrud.prototype, "formAddTitle", void 0);
__decorate([
    Prop({ required: true })
], SimpleCrud.prototype, "formEditTitle", void 0);
__decorate([
    Prop({ required: true })
], SimpleCrud.prototype, "headers", void 0);
__decorate([
    Prop({ required: true })
], SimpleCrud.prototype, "defaultItem", void 0);
__decorate([
    Prop({ default: false })
], SimpleCrud.prototype, "disableFiltering", void 0);
__decorate([
    Prop({ default: false })
], SimpleCrud.prototype, "disablePagination", void 0);
__decorate([
    Prop()
], SimpleCrud.prototype, "customFilter", void 0);
__decorate([
    Prop({ default: 'individual' })
], SimpleCrud.prototype, "sortBy", void 0);
__decorate([
    Prop({ default: false })
], SimpleCrud.prototype, "sortDesc", void 0);
__decorate([
    Prop({ default: true })
], SimpleCrud.prototype, "canAdd", void 0);
__decorate([
    Prop({ default: () => () => true })
], SimpleCrud.prototype, "canEditItem", void 0);
__decorate([
    Prop({ default: false })
], SimpleCrud.prototype, "hideDelete", void 0);
__decorate([
    Prop({ default: false })
], SimpleCrud.prototype, "hideShowDeletedToggle", void 0);
__decorate([
    Prop({ default: null })
], SimpleCrud.prototype, "isSuperseded", void 0);
SimpleCrud = __decorate([
    Component
], SimpleCrud);
export default SimpleCrud;
